// Data
import ageGroups from '/data/age-groups'

const monthsToAgeGroup = (months) => {
	let group = ageGroups.find((group) => ( group.start_months <= months && (group.end_months === false || group.end_months >= months) ))
	return group ? group : ageGroups[ageGroups.length - 1];
}

export default monthsToAgeGroup;